module.exports = __webpack_public_path__ + "static/media/CocaineActive.a54ff1be.svg";